import type { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import { Tag, Tooltip } from '@cobliteam/ui/components';
import type { TagProps } from '@cobliteam/ui/components/Tag';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import getStatusContent from './utils';

interface DeviceStatusProps extends Omit<TagProps, 'label' | 'color'> {
  status: DeviceGeneralStatus;
  hideLabel?: boolean;
  showTooltip?: boolean;
}

const DeviceStatus = ({ status, hideLabel, showTooltip = true, variant = 'surface', ...props }: DeviceStatusProps) => {
  const { iconName, color, label, tooltip } = getStatusContent(status);

  const TagContent = () => (
    <Tag data-testid='device-status' variant={variant} color={color} icon={<Icon name={iconName as IconNames} />} label={hideLabel ? undefined : label} {...props} />
  );

  if (showTooltip) {
    return (
      <Tooltip content={tooltip} className='w-52' align='start' position='bottom'>
        <TagContent />
      </Tooltip>
    );
  }

  return <TagContent />;
};

export default DeviceStatus;
